import { Accessor, JSX, JSXElement, Setter, createContext, createSignal, requireContext, useContext } from "common";

export class FKInputContext {
    valueChild: Accessor<JSXElement | undefined>;
    setValueChild: Setter<JSXElement | undefined>;

    rowChild: Accessor<JSXElement | undefined>;
    setRowChild: Setter<JSXElement | undefined>;

    constructor() {
        [this.valueChild, this.setValueChild] = createSignal<JSXElement>();
        [this.rowChild, this.setRowChild] = createSignal<JSXElement>();
    }
}

export const FKInputContextJsx = createContext<FKInputContext>();
export function requireFKInputContext() {
    return requireContext(FKInputContextJsx);
}
